export default "__VITE_ASSET__Cn6jpEP8__"